import { inject, Injectable } from '@angular/core';
import { SIGNATURE_LOCAL_STORAGE_KEY } from './consts/signature-local-storage-keys.const';
import { lastValueFrom, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CardPaymentsActivationService {
  private httpClient = inject(HttpClient);
  sig: string | null = null;
  constructor() {}

  public async convertSignatureDataUrlToFile(dataUrl: string): Promise<File> {
    const response = await lastValueFrom(
      this.httpClient.get(dataUrl, {
        responseType: 'arraybuffer',
      })
    );

    const blob = new Blob([response], { type: 'image/png' });
    const file = new File([blob], 'signature.png', {
      type: 'image/png',
    });

    return file;
  }

  public async getSignatureFile() {
    const dataUrl = this.sig;

    if (!dataUrl) {
      return null;
    }

    return this.convertSignatureDataUrlToFile(dataUrl);
  }

  public async getSignatureUrl() {
    return this.sig
  }

  public async saveSignature(dataUrl: string) {
    this.sig = dataUrl;
  }

  public async clearSignature() {
    this.sig = null;
  }

  public async saveBusinessEntityData(businessType: string) {
    const userID = parseInt(localStorage.getItem('userId')!);

    const body =JSON.stringify({
      "userid": userID,
      "business_type": businessType,
    });

    this.httpClient.post(`${environment['MERCHANT_EXTRAS']}/extrasapi/business-type`, body, {
      headers: new HttpHeaders( {
        'Content-Type': 'application/json',
      }),
    }).subscribe((response) => {
      console.log('Business entity data saved:', response);
    });
  }

  fetchBusinessEntityData() {
    const userID = parseInt(localStorage.getItem('userId')!);
    return this.httpClient.get(`${environment['MERCHANT_EXTRAS']}/extrasapi/business-type/${userID}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    }) as any as Observable<{ business_type: string }>;
  }
}
